

















import { Component, Prop, Vue } from 'vue-property-decorator';
import TaftUserInitials from '@/components/base-layout/TaftUserInitials.vue';

@Component({
  components: { TaftUserInitials },
})
export default class TaftUserName extends Vue {
  @Prop(String)
    name!: string;
  @Prop({ type: String, default: 'dark' })
    theme!: string; // light, dark
  @Prop({ type: Boolean, default: true })
    showInitials!: boolean; // light, dark
}
